// @module BluePoint.CustomLoader.CustomLoader
define('BluePoint.CustomLoader.CustomLoader.View'
,	[
	'bluepoint_customloader_customloader.tpl'
	
	,	'BluePoint.CustomLoader.CustomLoader.SS2Model'
	
	,	'Backbone'
    ]
, function (
	bluepoint_customloader_customloader_tpl
	
	,	CustomLoaderSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class BluePoint.CustomLoader.CustomLoader.View @extends Backbone.View
	return Backbone.View.extend({

		template: bluepoint_customloader_customloader_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new CustomLoaderModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BluePoint.CustomLoader.CustomLoader.View.Context
	,	getContext: function getContext()
		{
			//@class BluePoint.CustomLoader.CustomLoader.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
